// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__H-T9E","col":"styles_col__dOy8l"};